module.exports = __webpack_public_path__ + "static/media/YS_skyline_Mobile_AE_B1_v2.aaae7ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_skyline_Mobile_AE_B1_v2.jpg
// module id = 163
// module chunks = 0